module.exports = __webpack_public_path__ + "img/InstantBook.8f958f80.png";